import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Problem from "@/components/site/Problem";
import HowItWorks from "@/components/site/HowItWorks";
import Stats from "@/components/site/Stats";
import Founder from "@/components/site/Founder";
import Waitlist from "@/components/site/Waitlist";
import Footer from "@/components/site/Footer";

export default function Landing() {
    return (
        <div data-testid="landing-page" className="relative">
            <Header />
            <main id="main">
                <Hero />
                <Marquee />
                <Problem />
                <HowItWorks />
                <Stats />
                <Founder />
                <Waitlist />
            </main>
            <Footer />
        </div>
    );
}
